import { useState } from "react";
import { toast } from "sonner";
import { X, Loader2, KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export const ChangePasswordModal = ({ onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("Nieuw wachtwoord moet minstens 6 tekens zijn"); return; }
    if (next !== confirm) { toast.error("De nieuwe wachtwoorden komen niet overeen"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Wachtwoord gewijzigd! Gebruik dit voortaan om in te loggen.");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Wijzigen mislukt");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4">
      <form onSubmit={submit} data-testid="change-password-form" className="bg-[#111] border border-white/10 w-full max-w-md p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <KeyRound className="text-[#FF1A1A]" size={20} />
            <h3 className="font-heading text-xl font-bold text-white">Wachtwoord wijzigen</h3>
          </div>
          <button type="button" onClick={onClose}><X className="text-white/50 hover:text-white" /></button>
        </div>
        <div className="flex flex-col gap-5">
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Huidig wachtwoord" data-testid="current-password-input" className="w-full bg-transparent border-b border-white/20 focus:border-[#FF1A1A] outline-none py-2.5 text-white placeholder:text-white/30" />
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="Nieuw wachtwoord" data-testid="new-password-input" className="w-full bg-transparent border-b border-white/20 focus:border-[#FF1A1A] outline-none py-2.5 text-white placeholder:text-white/30" />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Bevestig nieuw wachtwoord" data-testid="confirm-password-input" className="w-full bg-transparent border-b border-white/20 focus:border-[#FF1A1A] outline-none py-2.5 text-white placeholder:text-white/30" />
          <button type="submit" disabled={saving} data-testid="submit-change-password" className="bg-[#FF1A1A] text-white px-8 py-3.5 font-semibold hover:bg-[#E60000] transition-colors flex items-center justify-center gap-2 mt-2 disabled:opacity-60">
            {saving ? <><Loader2 size={18} className="animate-spin" /> Opslaan...</> : "Wachtwoord wijzigen"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePasswordModal;
